export default __webpack_public_path__ + "static/media/1776.916052c7.png";